function bibtex_popup(authorBibtexID) {
    var w = window.open('', '', 'width=400,height=400,resizeable,scrollbars');
    w.document.write($("#"+authorBibtexID).html());
    w.document.close(); // needed for chrome and safari
}
